/* eslint-disable react/prop-types */
import React, { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import MegaMenuLanguages from './MegaMenuLanguages';
import MegaMenuMobileButtonLink from './MegaMenuMobileButtonLink';
import MegaMenuMobileColumnItemHeader from './MegaMenuMobileColumnItemHeader';
import MegaMenuMobileColumnItemContent from './MegaMenuMobileColumnItemContent';
import MegaMenuSearch from './MegaMenuSearch.tsx';
import BlurOverlay from '../../../../components/react/BlurOverlay.tsx';
import { disableBodyScroll } from '../../redesign/util/bodyScroll.ts';

const MegaMenuMobile = ({ megaMenu }) => {
  const [isOpenHamburger, setIsOpenHamburger] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const [openFirstLevelIndex, setOpenFirstLevelIndex] = useState(null);
  const [openSecondLevelIndex, setOpenSecondLevelIndex] = useState(null);

  const handleHamburgerClick = () => {
    if (isOpenHamburger) {
      disableBodyScroll(false);
    } else {
      disableBodyScroll(true);
    }
    setIsOpenHamburger(old => !old);
    setIsOpenSearch(old => (old === false ? old : false));
    setOpenFirstLevelIndex(old => (old === null ? old : null));
    setOpenSecondLevelIndex(old => (old === null ? old : null));
  };

  const handleSearchClick = () => {
    if (isOpenHamburger) {
      disableBodyScroll(false);
    }
    setIsOpenSearch(old => !old);
    setIsOpenHamburger(old => (old === false ? old : false));
    setOpenFirstLevelIndex(old => (old === null ? old : null));
    setOpenSecondLevelIndex(old => (old === null ? old : null));
  };

  const closeSearch = () => {
    setIsOpenSearch(old => (old === false ? old : false));
    setIsOpenHamburger(old => (old === false ? old : false));
    setOpenFirstLevelIndex(old => (old === null ? old : null));
    setOpenSecondLevelIndex(old => (old === null ? old : null));
  };

  const handleFirstLevelClick = index => {
    setIsOpenSearch(old => (old === false ? old : false));
    setOpenFirstLevelIndex(index);
  };

  const handleSecondLevelClick = index => {
    setIsOpenSearch(old => (old === false ? old : false));
    setOpenSecondLevelIndex(index);
  };

  const getAllColumnItems = () => {
    if (openFirstLevelIndex === null) {
      return [];
    }

    const result = [
      ...(megaMenu?.topNavigation?.expandedValue?.[openFirstLevelIndex]
        ?.megaMenuColumn1?.expandedValue || [])
    ];
    if (
      megaMenu?.topNavigation?.expandedValue?.[openFirstLevelIndex]
        ?.megaMenuColumn2?.expandedValue
    ) {
      result.push(
        ...(megaMenu?.topNavigation?.expandedValue?.[openFirstLevelIndex]
          ?.megaMenuColumn2?.expandedValue || [])
      );
    }
    if (
      megaMenu?.topNavigation?.expandedValue?.[openFirstLevelIndex]
        ?.megaMenuColumn3?.expandedValue
    ) {
      result.push(
        ...(megaMenu?.topNavigation?.expandedValue?.[openFirstLevelIndex]
          ?.megaMenuColumn3?.expandedValue || [])
      );
    }

    return result;
  };
  const allColumnItems = useMemo(
    () => getAllColumnItems(),
    [openFirstLevelIndex]
  );

  return (
    <div
      className={`mega-menu-mobile__nav-bar-container mega-menu--mobile ${
        isOpenHamburger || isOpenSearch
          ? 'mega-menu__nav-bar-container--open'
          : ''
      }`}
    >
      <div className="mega-menu-mobile__nav-bar">
        <div className="mega-menu-mobile__nav-bar-content redesign__margin-container">
          <div className="mega-menu-mobile__nav-bar-logo">
            <a href="/">
              <img
                src={megaMenu.siteLogo?.expandedValue?.url}
                alt={
                  megaMenu.siteLogo?.expandedValue?.altText?.value ||
                  megaMenu.siteLogo?.name
                }
                width={140}
              />
            </a>
          </div>
          <div className="mega-menu-mobile__nav-items">
            <button onClick={() => handleSearchClick()}>
              <svg
                role="presentation"
                className="mega-menu-mobile__nav-bar-icon"
              >
                <use xlinkHref={isOpenSearch ? '#close' : '#search-icon'} />
              </svg>
            </button>
            <button onClick={() => handleHamburgerClick()}>
              <svg
                role="presentation"
                className="mega-menu-mobile__nav-bar-icon"
              >
                <use
                  xlinkHref={isOpenHamburger ? '#close' : '#burger-menu-icon'}
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div
        className={`mega-menu-mobile__content-level mega-menu-mobile__content ${
          isOpenHamburger && openFirstLevelIndex === null
            ? 'mega-menu-mobile__content--open'
            : ''
        } ${
          isOpenHamburger || isOpenSearch
            ? 'mega-menu-mobile__content--any-open'
            : ''
        }`}
      >
        <div className="redesign__margin-container ">
          <ul className="mega-menu-mobile__link-container">
            {megaMenu?.topNavigation?.expandedValue?.map((section, index) => (
              <li key={`mobile-nav-${index}-${section?.title?.value}`}>
                <MegaMenuMobileButtonLink
                  onTitleClick={() => handleFirstLevelClick(index)}
                  href={section?.url?.value}
                  title={section?.title?.value || section.name}
                />
              </li>
            ))}
          </ul>
          <MegaMenuLanguages
            languagesExpandedValue={megaMenu.languagesArea?.expandedValue}
          />
        </div>
      </div>
      <div
        className={`mega-menu-mobile__content-level mega-menu-mobile__content  ${
          isOpenHamburger &&
          openFirstLevelIndex !== null &&
          openSecondLevelIndex === null
            ? 'mega-menu-mobile__content--open'
            : ''
        } ${
          isOpenHamburger || isOpenSearch
            ? 'mega-menu-mobile__content--any-open'
            : ''
        }`}
      >
        <div className="redesign__margin-container">
          <div className="mega-menu-mobile__level-header">
            <button
              className="mega-menu-mobile__back-button"
              onClick={() =>
                setOpenFirstLevelIndex(old => (old === null ? old : null))
              }
            >
              <svg role="presentation">
                <use xlinkHref="#square-arrow-left" />
              </svg>
              Back
            </button>
            <span className="mega-menu-mobile__level-title">
              {
                megaMenu?.topNavigation?.expandedValue?.[openFirstLevelIndex]
                  ?.title?.value
              }
            </span>
          </div>
          <ul>
            {allColumnItems.map((block, index) => (
              <MegaMenuMobileColumnItemHeader
                onTitleClick={() => handleSecondLevelClick(index)}
                key={`second-level-${index}-${block?.name}`}
                item={block}
              />
            ))}
          </ul>
        </div>
      </div>
      <div
        className={`mega-menu-mobile__content-level mega-menu-mobile__content ${
          isOpenHamburger && openSecondLevelIndex !== null
            ? 'mega-menu-mobile__content--open'
            : ''
        } ${
          isOpenHamburger || isOpenSearch
            ? 'mega-menu-mobile__content--any-open'
            : ''
        }`}
      >
        <div className="redesign__margin-container">
          <div className="mega-menu-mobile__level-header">
            <button
              className="mega-menu-mobile__back-button"
              onClick={() =>
                setOpenSecondLevelIndex(old => (old === null ? old : null))
              }
            >
              <svg role="presentation">
                <use xlinkHref="#square-arrow-left" />
              </svg>
              Back
            </button>
            <span className="mega-menu-mobile__level-title">
              {openSecondLevelIndex !== null &&
                allColumnItems[openSecondLevelIndex].title?.value}
            </span>
          </div>
          {openSecondLevelIndex !== null && (
            <MegaMenuMobileColumnItemContent
              item={allColumnItems[openSecondLevelIndex]}
            />
          )}
        </div>
      </div>
      <div
        className={`mega-menu-mobile__content mega-menu-mobile__content-search ${
          !isOpenHamburger && isOpenSearch
            ? 'mega-menu-mobile__content--open'
            : ''
        } ${
          isOpenHamburger || isOpenSearch
            ? 'mega-menu-mobile__content--any-open'
            : ''
        }`}
      >
        <div className="redesign__margin-container">
          <MegaMenuSearch
            isSearchOpen={isOpenSearch}
            searchPageUrl={megaMenu.searchPage?.value?.url}
          />
        </div>
      </div>
      {createPortal(
        <BlurOverlay
          visible={isOpenSearch}
          onClick={() => closeSearch(false)}
        />,
        document.body
      )}
    </div>
  );
};

export default MegaMenuMobile;
